// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Icon from './icon';

// Styles
import './loading.scss';

class Loading extends Component {
    state = {
        height: undefined,
    };

    getClass() {
        const {className, small} = this.props;
        return classnames(
            {
                loading: true,
                loading_small: small,
            },
            className
        );
    }

    calcOffsetHeight = (loader) => {
        const {height: heightState} = this.state;

        if (loader && loader.offsetParent) {
            const height = loader.offsetParent.scrollHeight;

            if (height && heightState !== height) {
                this.setState({height});
            }
        }
    };

    render() {
        const {height} = this.state;
        const {loading} = this.props;

        return loading ? (
            <div className={this.getClass()} ref={this.calcOffsetHeight} style={{minHeight: height}}>
                <Icon className="loading--icon" fontType="fa" iconName="spinner" spin={true} />
            </div>
        ) : null;
    }
}

Loading.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    small: PropTypes.bool,
};

export default Loading;
